import { __assign, __rest } from "tslib";
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons/faLightbulb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import asRendition from '../../asRendition';
import { DismissableContainer, } from '../../internal/DismissableContainer';
import { getColor } from '../../utils';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { Txt } from '../Txt';
var getTitle = function (props) {
    if (props.prefix === false) {
        return;
    }
    if (props.prefix !== undefined) {
        return props.prefix;
    }
    return props.danger
        ? 'Danger!'
        : props.warning
            ? 'Warning!'
            : props.success
                ? 'Success!'
                : props.info
                    ? 'Note!'
                    : '';
};
var getIcon = function (props) {
    if (props.prefix === false) {
        return;
    }
    if (props.prefix !== undefined) {
        return;
    }
    return props.danger
        ? faBan
        : props.warning
            ? faExclamationTriangle
            : props.success
                ? faCheckCircle
                : props.info
                    ? faLightbulb
                    : '';
};
var BaseAlert = function (props) {
    var emphasized = props.emphasized, plaintext = props.plaintext, prefix = props.prefix, onDismiss = props.onDismiss, restProps = __rest(props, ["emphasized", "plaintext", "prefix", "onDismiss"]);
    var icon = getIcon(props);
    var title = plaintext ? null : getTitle(props);
    var mainColor = getColor(props, 'color', 'main');
    var darkColor = getColor(props, 'color', 'dark');
    var lineHeight = props.theme.fontSizes[2] * props.theme.lineHeight;
    if (plaintext) {
        return (React.createElement(Flex, __assign({}, restProps),
            icon && (React.createElement(Txt, { color: mainColor, mb: "auto", mr: 2 },
                React.createElement(FontAwesomeIcon, { icon: icon }))),
            React.createElement(Txt.span, { color: darkColor }, props.children)));
    }
    return (React.createElement(DismissableContainer, __assign({ baselineHeight: lineHeight, solid: emphasized, color: mainColor, onDismiss: onDismiss, a11yTitle: "Dismiss Alert" }, restProps),
        icon && (React.createElement(Txt, { color: mainColor, mb: "auto", mr: 2 },
            React.createElement(FontAwesomeIcon, { icon: icon }))),
        React.createElement(Box, { color: darkColor, flex: 1 },
            title && (React.createElement(Txt.span, { bold: true, mr: 1 }, title)),
            React.createElement(Txt.span, { color: emphasized ? darkColor : 'text.main' }, props.children))));
};
export var Alert = asRendition(BaseAlert, [], ['bg']);
